import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Box, Card, Tooltip, Typography, Skeleton } from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
} from '@mui/icons-material';
import { get } from 'lodash';

function CounterWithTrend({
  loading,
  label,
  value,
  icon,
  percentage,
  variant = 'elevation',
  hideTrendIcon = false,
  numberProps = {},
}: any) {
  const TrendIcon = percentage >= 0 ? TrendingUpIcon : TrendingDownIcon;
  let trendColor = percentage >= 0 ? 'success.main' : 'error.main';

  if (hideTrendIcon) {
    trendColor = 'text.primary';
  }

  return (
    <Card
      variant={variant}
      sx={(theme: any) => ({
        padding: theme.spacing(2, 2, 1, 2),
        height: '100%',
      })}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography variant="body2" component="h2" sx={{ fontWeight: 'medium' }}>
          {label}
        </Typography>
        {icon}
      </Box>

      {(loading || value === undefined || Number.isNaN(value)) && (
        <Box sx={{ mt: 1, mb: 1 }}>
          <Skeleton variant="rectangular" height={24} width="15%" />
          {percentage !== undefined && (
            <>
              <Box sx={{ mt: 2 }} />
              <Skeleton variant="rectangular" height={16} width="25%" />
            </>
          )}
        </Box>
      )}

      {!loading && value !== undefined && !Number.isNaN(value) && (
        <Typography variant="h4" component="h3" sx={{ fontWeight: 'bold' }}>
          <FormattedNumber value={value} notation="standard" {...numberProps} />
        </Typography>
      )}

      {!loading && !!percentage && (
        <Tooltip
          title={<FormattedMessage id="STATS.COUNTER_WITH_TREND.TOOLTIP" />}
          disableHoverListener={hideTrendIcon}
          arrow
        >
          <Box
            sx={(theme: any) => ({
              color: get(theme.palette, trendColor),
              display: 'inline-flex',
              fontWeight: 'bold',
            })}
          >
            <Typography variant="subtitle2" component="p">
              {!hideTrendIcon && percentage > 0 && '+'}
              <FormattedNumber
                value={percentage / 100}
                style="percent"
                minimumFractionDigits={percentage < 100 ? 1 : 0}
              />
            </Typography>
            {!hideTrendIcon && (
              <Box sx={{ ml: 1 }}>
                <TrendIcon />
              </Box>
            )}
          </Box>
        </Tooltip>
      )}
    </Card>
  );
}

export default CounterWithTrend;
